import {Campaign} from "../../common/models/Campaign";
import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {CommandResult} from "../../common/helpers/CommandResult";

export const putCampaign = (id: number, campaign: Partial<Campaign>): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .put(`/api/campaigns/${id}`, campaign)
        .then((result) => new CommandResult(result));
};